module.exports = __webpack_public_path__ + "img/production-management.1a79baa0.png";